import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import LayOut from "../components/LayOut";

const ForgotPassword = () => {
  const [formData, setFormData] = useState({ email: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        "https://portfoliomern-mxue.onrender.com/api/v1/auth/forgot-password",
        {
          email: formData.email,
        }
      );

      if (res.data.success) {
        toast.success(res.data.message); // success message like "Email sent!"
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Forgot Password Error:", error);
      toast.error("Error sending email. Try again later.");
    }
  };

  return (
    <LayOut title={"Forgot Password"}>
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="login-container">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="email"
                className="form-control"
                placeholder="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 text-center">
              <button type="submit" className="btn btn-pink w-100">
                Send Reset Link
              </button>
            </div>
          </form>
        </div>
      </div>
    </LayOut>
  );
};

export default ForgotPassword;
